export default __webpack_public_path__ + "static/media/UG5-county.e6feac46.jpg";